import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cc207582"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "main-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Raffish PowerUp Store", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "What are PowerUps and what can they do?"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Think of a PowerUp as something you can plug into your Sprinklr environment — a focused add-on that gives you exactly the extra capability you need without onboarding another software. ")
], -1))
const _hoisted_5 = { class: "powerups" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_tile = _resolveComponent("app-tile")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("main", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableApps, (app, appName) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "card",
            key: appName
          }, [
            _createVNode(_component_app_tile, {
              name: appName,
              title: app.title,
              description: app.short_description,
              installed: _ctx.isInstalled(appName),
              subscribed: _ctx.isSubscribed(appName),
              icon: app.icon,
              pricing: app.pricing,
              onOpen: ($event: any) => (_ctx.openApp(appName)),
              onInstall: ($event: any) => (_ctx.openApp(appName))
            }, null, 8, ["name", "title", "description", "installed", "subscribed", "icon", "pricing", "onOpen", "onInstall"])
          ]))
        }), 128))
      ])
    ])
  ]))
}